



































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { Participant } from "@scrile/api-provider/dist/api/ParticipantProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseButton from "@/components/BaseButton";
import ModalView from "@/components/ModalView";
import ConsentDataDescription from "./ConsentDataDescription.vue";
import ConsentFormVerifiedView from "./ConsentFormVerifiedView.vue";
import ConsentIdentityForm from "./ConsentIdentityForm.vue";
import ConsentSignForm from "./ConsentSignForm.vue";

export default defineComponent({
  name: "ConsentFormModal",
  components: {
    ConsentIdentityForm,
    ConsentDataDescription,
    ConsentFormVerifiedView,
    BaseButton,
    ConsentSignForm,
    ModalView,
  },
  props: {
    show: { type: Boolean, default: false },
    participant: { type: Object as PropType<Participant>, required: true },
    owner: { type: Object as PropType<UserPublicData>, default: null },
  },
  setup(_, { emit }) {
    const { isMember } = useAuthUser();
    const signValid = ref(false);
    const identityValid = ref(true);
    const processing = ref(false);

    const isValid = computed(() => signValid.value && identityValid.value);

    const onSubmit = () => {
      if (!isValid.value) return;
      processing.value = true;
      emit("submit", () => {
        processing.value = false;
      });
    };

    return {
      isValid,
      processing,
      isMember,
      identityValid,
      signValid,
      onSubmit,
      getProfileUrl,
    };
  },
});
